/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRemoteMcpServerHeaderSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRemoteMcpServerHeaderSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRemoteMcpServerHeaderSecurity = {
  option1?: GetRemoteMcpServerHeaderSecurityOption1 | undefined;
  option2?: GetRemoteMcpServerHeaderSecurityOption2 | undefined;
};

export type GetRemoteMcpServerHeaderRequest = {
  /**
   * The ID of the header
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRemoteMcpServerHeaderSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRemoteMcpServerHeaderSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetRemoteMcpServerHeaderSecurityOption1$Outbound,
    GetRemoteMcpServerHeaderSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getRemoteMcpServerHeaderSecurityOption1ToJSON(
  getRemoteMcpServerHeaderSecurityOption1:
    GetRemoteMcpServerHeaderSecurityOption1,
): string {
  return JSON.stringify(
    GetRemoteMcpServerHeaderSecurityOption1$outboundSchema.parse(
      getRemoteMcpServerHeaderSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRemoteMcpServerHeaderSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRemoteMcpServerHeaderSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetRemoteMcpServerHeaderSecurityOption2$Outbound,
    GetRemoteMcpServerHeaderSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getRemoteMcpServerHeaderSecurityOption2ToJSON(
  getRemoteMcpServerHeaderSecurityOption2:
    GetRemoteMcpServerHeaderSecurityOption2,
): string {
  return JSON.stringify(
    GetRemoteMcpServerHeaderSecurityOption2$outboundSchema.parse(
      getRemoteMcpServerHeaderSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRemoteMcpServerHeaderSecurity$Outbound = {
  Option1?: GetRemoteMcpServerHeaderSecurityOption1$Outbound | undefined;
  Option2?: GetRemoteMcpServerHeaderSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRemoteMcpServerHeaderSecurity$outboundSchema: z.ZodMiniType<
  GetRemoteMcpServerHeaderSecurity$Outbound,
  GetRemoteMcpServerHeaderSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRemoteMcpServerHeaderSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRemoteMcpServerHeaderSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRemoteMcpServerHeaderSecurityToJSON(
  getRemoteMcpServerHeaderSecurity: GetRemoteMcpServerHeaderSecurity,
): string {
  return JSON.stringify(
    GetRemoteMcpServerHeaderSecurity$outboundSchema.parse(
      getRemoteMcpServerHeaderSecurity,
    ),
  );
}

/** @internal */
export type GetRemoteMcpServerHeaderRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRemoteMcpServerHeaderRequest$outboundSchema: z.ZodMiniType<
  GetRemoteMcpServerHeaderRequest$Outbound,
  GetRemoteMcpServerHeaderRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRemoteMcpServerHeaderRequestToJSON(
  getRemoteMcpServerHeaderRequest: GetRemoteMcpServerHeaderRequest,
): string {
  return JSON.stringify(
    GetRemoteMcpServerHeaderRequest$outboundSchema.parse(
      getRemoteMcpServerHeaderRequest,
    ),
  );
}
